const server = 'http://localhost:3000';

let customer = {
    token: 'a4cdb96e-b2be-4709-b143-b7af3fea7a42a4cdb96e-b2be-4709-b143-b7af3fea7a42a4cdb96e-b2be-4709-b143-b7af3fea7a42',
    logo: 'https://uploads-ssl.webflow.com/6184df18a5e0b4af1071baca/61b8a98e5d85828385de9c38_Logo.svg',
    companyLogo: 'customerfirst.png',
    companyLogoHeight: '40px',
    company: 'Customer First AB',
    companyName: 'CustomerFirst',
    tele: '08-459 00 30',
    email: 'info@customerfirst.se',
    mailToLink: true,
    mailToMailtoLink: 'info@customerfirst.se',
    primaryColor: 'indigo darken-3', //need to be material design string
    primaryColorHex: '#009382',
    secondaryColorHex: '#009382',
    secondaryColorHexHeader: '#FFFFFF',
    primaryGradient: 'linear-gradient(90deg, rgba(38,38,38,1) 0%, rgba(38,38,38,1) 100%)',
    secondaryColor: 'white',
    showPhoneSimple: true,
    showProfilePictures: true,
    showCustomerNameInHeader: true,
    showPhone: false,
    showCallback: false,
    showBooking: false,
    enableJumpAnimation: true,
    showMail: true,
    showChat: true,
    showFaq: false,
    showLogoHeader: true,
    autostartChat: false,
    iconToggle: ['chat_bubble', 'chat'],
    iconToggleView: true,
    textToggleTop: ['Behöver du hjälp? Kontakta oss!'],
    phoneText: 'Kontaktuppgifter',
    canMinimize: true,
    relationId: 'customerfirst-chat',
    showProfilesTop: true,
    heading: 'Chatta med kundservice och våra digitala säljare!',
    profilePeople: [
        'https://randomuser.me/api/portraits/women/43.jpg',
        'https://randomuser.me/api/portraits/women/44.jpg',
        'https://randomuser.me/api/portraits/men/43.jpg',
        'https://randomuser.me/api/portraits/men/46.jpg',
        'https://randomuser.me/api/portraits/men/47.jpg'
    ],
    simplePhoneText: [
        { heading: 'Telefon', number: '031-727 87 00' },
        { heading: 'Öppettider', number: 'Måndag-Torsdag: 09-18<br/>Fredagar: 10-16' }
    ],
    descriptionText: {
        chatClosed: 'Öppettider 08-17, <br/>helgfria vardagar',
        chatOpen: 'Chatta med oss',
        telephone: 'Måndag-Torsdag: 09-17<br/>Fredagar: 09-17',
        mail: 'info@customerfirst.se',
        contact: 'Hitta medarbetare',
        faq: 'Enkla frågor & svar',
        taxi: 'Boka direkt'
    }
};

module.exports = {
    logo: customer.logo,
    server,
    company: customer.company,
    customer,
    token: '4F93C04A-9422-4C4A-A8F9-C0C4B5092D4C-35A370BD-AB10-4F07-A9E6-ECE50DD901A6-981A2AEA-A155-40DF-BA8A-F57DCC96CAA2-9A982994-A4AA-4296-9B84-0660691DCDB2-8D0AA9A6-0B45-47B0-B524-3139D3A4EB62'
};
